import { environment } from '../environments/environment';

const config = {
  ...environment,
};
export default config;
